import { Result } from 'antd'
import { FC } from 'react'
import { CloneTimelineRes } from 'src/service/OrgSyncService'

interface MigrateResultPageProps {
  res?: CloneTimelineRes
}

const MigrateResultPage: FC<MigrateResultPageProps> = ({ res }) => {
  return res ? (
    <Result
      status="success"
      title="Successfully migrated the timeline!"
      subTitle={`Keypoints created: ${res.keypoints_created}, Deliveries created: ${res.deliveries_created}`}
      extra={[
        <button
          onClick={() => miro.board.ui.closeModal()}
          className="button sticky button-primary "
          key="console"
        >
          Back to Home
        </button>,
      ]}
    />
  ) : null
}

export default MigrateResultPage
